import { get } from "@services/apiService.js";

export default {
  getPreset({ type, metaName, pageType, groupType}) {
    let query = '';
    if(pageType && groupType) {
      query = `&group_type=${groupType}&page_type=${pageType}`
    }
    return get(`/v4/design-manager/v1/presets/${metaName}?version=${process.env.VUE_APP_RENDER_VERSION}&type=${type}${query}`, {})
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  getPresetRender({ id, metaName, languageUse, metaDataID}) {
    return get(`/v4/design-manager/v1/presets/${metaName}/${id}/render?version=${process.env.VUE_APP_RENDER_VERSION}&language=${languageUse}&pageID=${metaDataID}`, {})
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  getSectionWidget({ type }) {
    return get(`/v4/design-manager/v1/presets/widget?version=${process.env.VUE_APP_RENDER_VERSION}&type=${type}`, {})
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
};
